import { Box, TextField, Typography } from '@mui/material';
import { JSXInternal } from 'preact/src/jsx';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { Color } from '../../commun/Constant';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import Category from '../../object/tag/Category';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { SelectColor } from '../SelectColor';

export interface IAddCategoryModalProps extends IBaseModalProps {
    category?: Category;
}

export interface IAddCategoryModalState {
    name: string;
    color: Color;
    loading: boolean;
    error: string;
}

export default class AddCategoryModal extends Component<IAddCategoryModalProps, IAddCategoryModalState> {
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IAddCategoryModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();
    }

    initState() {
        const p: IAddCategoryModalState = {
            name: this.props.category?.name.get() ?? '',
            color: this.props.category?.getColor() ?? 'blue',
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IAddCategoryModalProps>,
        prevState: Readonly<IAddCategoryModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addVendor() {
        const { name, color } = this.state;
        this.setState({
            loading: true,
            error: '',
        });
        post('/category/update', {
            id: this.props.category?.getAjoIdentifier() ?? '',
            name: name,
            color: color,
        }).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);
                this.props.onClose();
                if (this.props.category !== undefined) {
                    AppManager.addToast(new Toast('La catégorie a été modifié avec succès.', 'success'));
                } else {
                    AppManager.addToast(new Toast('La catégorie a été ajouté avec succès.', 'success'));
                }
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading, name, error, color } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addVendor();
                }}
                title={this.props.category !== undefined ? 'Modifier une catégorie' : 'Ajouter une catégorie'}
                done={this.props.category !== undefined ? 'Modifier' : 'Ajouter'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-3">
                        <Typography className="!text-sm !font-semibold">NOM DE LA CATÉGORIE</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any).value });
                            }}
                            placeholder="Nom de la catégorie"
                            variant="outlined"
                        />
                        <Typography className="!text-sm !font-semibold">COULEUR DE LA CATÉGORIE</Typography>
                        <SelectColor
                            color={color}
                            onSelect={(color) => {
                                this.setState({
                                    color: color,
                                });
                            }}
                        />
                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
